import { useContext, useEffect } from 'react';

import { OptimizelyContext } from '@optimizely/react-sdk';

import { ConfigContext } from 'Context/config';
import { UserContext } from 'Context/user';

import { FLAG } from 'Utilities/analytics/optimizely/constants';
import { useFeatureFlags } from 'Utilities/hooks';

export const AUTH_UI_VARIANT = {
  OFF: 'off',
  ON: 'on',
};

const flag = FLAG.SWA_AUTH_UI;

export const useAuthUI = (triggerExperiment = false) => {
  const { userState: user } = useContext(UserContext);
  const { optimizely } = useContext(OptimizelyContext);
  const { configState: { experimentDecisions } } = useContext(ConfigContext);

  const experimentVariant = experimentDecisions?.[flag];

  const { useAuthUI: isAuthUIEnabledEngine } = useFeatureFlags();

  useEffect(() => {
    if (!triggerExperiment) {
      return;
    }

    optimizely?.onReady().then(() => {
      if (experimentDecisions?.[flag]) {
        optimizely.decide(flag);
      }
    });
  }, [experimentDecisions, optimizely, user, triggerExperiment]);

  const isAuthUIJourney = experimentVariant
    ? experimentVariant === AUTH_UI_VARIANT.ON
    : isAuthUIEnabledEngine;

  return {
    isAuthUIJourney,
  };
};
